import { useMemo } from 'react';
import { IFamilyMemberDto } from '../../../../utils/constants/interfaces';

interface UseMemberInformationProps {
  member: IFamilyMemberDto;
  isPrimary: boolean;
}

export const useMemberInformation = ({ member, isPrimary }: UseMemberInformationProps) => {
  const errorPrefix = useMemo(() => {
    return isPrimary ? 'overview:' : 'family:';
  }, [isPrimary]);

  const hasRequiredFields = useMemo(() => {
    return Boolean(member.firstName && member.lastName && member.emailAddress);
  }, [member.firstName, member.lastName, member.emailAddress]);

  return {
    errorPrefix,
    hasRequiredFields
  };
};
